import moment from 'moment';

export const calendarInitialState = {
  calendar: {
    data: {},
    meta: {
      isLoading: false,
      hasError: false,
      loaded: false
    },
    filters: {
      startDate: moment().add(-1, 'month').startOf('month'),
      endDate: moment(),
      grouping: {
        selected: null,
        options: []
      },
      status: {
        selected: null,
        options: []
      }
    }
  }
};
